import { Tabs, TabsContent, TabsList, TabsTrigger } from "@suns/design-system";
import { PlayersReportListings } from "./PlayersReportListings";
import { PlayerRow } from "@suns/api/generated-client/apollo";
import { PlayersAndTeamsIntelListings } from "./PlayersAndTeamsIntelListings";
import { PlayersStats } from "./PlayersStats";
import PlayerContracts from "./PlayerContracts";
import { PlayerAnalytics } from "./PlayerAnalytics";
import { PlayerScouting } from "./PlayerScouting";
import { useAccount } from "@/shared/hooks";

export function PlayerInfoSection({ player }: { player: PlayerRow }) {
  const { hasScoutAdminAccess, hasAdminAccess } = useAccount();

  const tabOptions = ["Stats"];

  if (hasAdminAccess || hasScoutAdminAccess) {
    tabOptions.unshift("Overview", "Scouting");
  }

  if (hasAdminAccess) {
    tabOptions.push("Contracts");
  }

  if (hasScoutAdminAccess) {
    tabOptions.push("Reports", "Intel");
  }

  return (
    <Tabs defaultValue={tabOptions[0]}>
      {tabOptions.length > 1 && (
        <TabsList className="mb-4 max-sm:w-full">
          {tabOptions.map((tab) => (
            <TabsTrigger
              key={tab}
              value={tab}
              className="px-2 max-sm:text-xs md:px-3"
            >
              {tab}
            </TabsTrigger>
          ))}
        </TabsList>
      )}
      <TabsContent value="Overview">
        <PlayerAnalytics player={player} />
      </TabsContent>
      <TabsContent value="Scouting">
        <PlayerScouting player={player} />
      </TabsContent>
      <TabsContent value="Stats" className="w-full">
        <PlayersStats player={player} />
      </TabsContent>
      <TabsContent value="Contracts">
        <PlayerContracts player={player} />
      </TabsContent>
      <TabsContent value="Reports">
        <PlayersReportListings />
      </TabsContent>
      <TabsContent value="Intel">
        <PlayersAndTeamsIntelListings />
      </TabsContent>
    </Tabs>
  );
}
